// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/inspector/inspector.scss
// module id = 27
// module chunks = 0